import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import poster from '../assets/event-poster.png';

const EVENT_URL = 'https://entradium.com/es/events/vivo-tinta-by-don-t-stop-en-sala-badulaque-madrid-2026/sessions/23-05-2026-19-00-bar-badulaque-don-t-stop';

/**
 * Event poster popup.
 * Opens whenever `triggerKey` changes (parent controls it): on initial
 * page load and every time the user navigates to "Sobre Mí".
 * Clicking the poster redirects to the ticket purchase URL.
 */
export default function EventPopup({ triggerKey }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (triggerKey === undefined || triggerKey === null) return;
    const t = setTimeout(() => setOpen(true), 500);
    return () => clearTimeout(t);
  }, [triggerKey]);

  const close = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setOpen(false);
  };

  const openLink = () => {
    window.open(EVENT_URL, '_blank', 'noopener,noreferrer');
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[2147483600] flex items-center justify-center p-4 sm:p-6 animate-[fadeIn_0.35s_ease-out]"
      role="dialog"
      aria-modal="true"
      aria-label="Presentación del libro Troquelada"
      onClick={close}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-[#2a1630]/70 backdrop-blur-sm" />

      {/* Poster (clickable) */}
      <div
        className="relative max-w-[420px] w-full"
        onClick={(e) => { e.stopPropagation(); openLink(); }}
      >
        <button
          type="button"
          onClick={close}
          aria-label="Cerrar"
          className="absolute -top-3 -right-3 sm:-top-4 sm:-right-4 w-9 h-9 rounded-full bg-white text-[#4b3a2d] shadow-lg flex items-center justify-center hover:bg-[#f6e6d4] focus:outline-none focus:ring-2 focus:ring-[#b89dd4] z-10"
        >
          <X className="w-5 h-5" strokeWidth={2.2} />
        </button>

        <img
          src={poster}
          alt="Presentación del libro Troquelada - 23 Mayo 2026"
          className="w-full h-auto rounded-2xl shadow-[0_30px_60px_-20px_rgba(0,0,0,0.6)] cursor-pointer transition-transform duration-300 hover:scale-[1.01]"
          draggable={false}
        />

        <p className="mt-3 text-center text-white/85 text-[0.78rem] sm:text-[0.82rem] font-body">
          Haz clic en el póster para ir a la compra de entradas
        </p>
      </div>
    </div>
  );
}
